export default __webpack_public_path__ + "static/media/etienne_flowers.9fe19df4.jpg";